module.exports = __webpack_public_path__ + "static/media/1443603138(1).a075ce0c.jpg";